import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      meta: { requiresAuth: true},
      component: Home,
    },
    {
      path: '/bandeja-entrada',
      name: 'inbox',
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "inbox" */ './views/Inbox.vue'),
    },
    {
      path: '/enviados-firmar',
      name: 'sent',
      meta: { requiresAuth: true },
      component: () => import('./views/Sent.vue'),
    },
    {
      path: '/detalle/:id',
      name: 'details',
      props: true,
      meta: { requiresAuth: true},
      component: () => import('./views/Details.vue'),
    },
    {
      path: '/borradores',
      name: 'drafts',
      props: true,
      meta: { requiresAuth: true },
      component: () => import('./views/Drafts.vue'),
    },
    {
      path: '/eliminados',
      name: 'deleted',
      props: true,
      meta: { requiresAuth: true },
      component: () => import('./views/Deleted.vue'),
    },
    {
      path: '/documento/:opt',
      name: 'documento',
      props: true,
      meta: { requiresAuth: true },
      component: () => import('./views/Documento.vue'),
    },
    {
      path: '/documento/:opt/:id',
      name: 'documento_edit',
      props: true,
      meta: { requiresAuth: true },
      component: () => import('./views/Documento.vue'),
    },
    {
      path: '/firmados',
      name: 'firmados',
      meta: { requiresAuth: true },
      component: () => import('./views/Firmados.vue'),
    },
    {
      path: '/expediente/crear',
      name: 'expediente_crear',
      component: () => import('./views/Expedientes/Carpeta.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/expediente/flujo/:opt',
      name: 'expediente_flujo_opt',
      component: () => import('./views/Admin/Flujo.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/expediente/flujos',
      name: 'expediente_flujo',
      component: () => import('./views/Admin/FlujoLista.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/expediente/documento',
      name: 'expediente_documento',
      component: () => import('./views/Expedientes/Documento.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/expediente/documento/:opt/:id',
      name: 'expediente_documento_edit',
      component: () => import('./views/Expedientes/Documento.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/expedientes/:id',
      name: 'expedientes',
      component: () => import('./views/Expedientes/Lista.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/carpeta/:id',
      name: 'carpeta_personal',
      component: () => import('./views/Expedientes/Lista.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/carpeta/:id',
      name: 'carpeta_lote',
      component: () => import('./views/Expedientes/Lista.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/logout',
      name: 'logout',
      meta: { requiresAuth: true },
      component: () => import('./views/Auth/Logout.vue'),
    },
    {
      path: '/inicio',
      name: 'login',
      meta: { requiresGuest: true},
      component: () => import('./views/Auth/Login.vue'),
    },
    {
      path: '/firmar_desde_correo',
      name: 'firmar_desde_correo',
      component: () => import('./views/FirmaDesdeCorreo.vue'),
      meta: { requiresGuest: true },
    },
    {
      path: '/cambio_clave',
      name: 'cambio_clave',
      meta: { requiresGuest: true},
      component: () => import('./views/Auth/Cambio_clave.vue'),
    },
    {
      path: '/registro',
      name: 'register',
      component: () => import('./views/Auth/Register.vue'),
      meta: { requiresGuest: true},
    },
    {
      path: '/membresia/new',
      name: 'new_membresia',
      component: () => import('./views/Membresia/new.vue'),
      meta: { requiresGuest: true },
    },
    {
      path: '/membresia/index',
      name: 'index_membresia',
      component: () => import('./views/Membresia/index.vue'),
      meta: { requiresGuest: true },
    },
    {
      path: '/membresia/edit',
      name: 'edit_membresia',
      component: () => import('./views/Membresia/edit.vue'),
      meta: { requiresGuest: true },
    },
    {
      path: '/usuario/index',
      name: 'index_usuario',
      component: () => import('./views/Usuarios/index.vue'),
      meta: { requiresGuest: true },
    },
    {
      path: '/usuario/membresia',
      name: 'usuario_membresia',
      component: () => import('./views/Usuarios/membresia.vue'),
      meta: { requiresGuest: true },
    },
    {
      path: '/rubrica',
      name: 'usuario_rubrica_index',
      component: () => import('./views/Rubricas/index.vue'),
      meta: { requiresAuth: true },
    },
  ],
});


        
                    
